"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.querystringToObj = exports.isInPopup = exports.isInIframe = exports.isBrowser = void 0;
const isBrowser = () => typeof window !== "undefined";
exports.isBrowser = isBrowser;
const isInIframe = () => {
    if (!exports.isBrowser())
        return false;
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
exports.isInIframe = isInIframe;
const isInPopup = () => {
    return exports.isBrowser() && !!window.opener;
};
exports.isInPopup = isInPopup;
const querystringToObj = (query) => {
    var _a, _b;
    let search = (_b = query !== null && query !== void 0 ? query : (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) !== null && _b !== void 0 ? _b : "";
    let params = new URLSearchParams(search);
    let obj = {};
    for (const [key, val] of params) {
        obj[key] = val;
        try {
            // detect if value is a URL with query parameters
            let nestedQueryObj = exports.querystringToObj(new URL(val).search);
            // merge and give priority to values already on the obj
            obj = Object.assign(Object.assign({}, nestedQueryObj), obj);
        }
        catch (e) {
            // not a url, just a regular key/value pair
            continue;
        }
    }
    return obj;
};
exports.querystringToObj = querystringToObj;
